import { Outlet, useLocation } from 'react-router-dom'

import { CallCenter } from '@/components/CallCenter'
import { SideBar } from '@/components/SideBar'
import { Show } from '@/components/Show'

import { PagesWrapper } from '@/shared/styles/pagesWrapper'
import { useIsActiveBreakPoint } from '@/hooks/useIsActiveBreakPoint'
import { CuraIcon } from '@rededor/cura-react'

import * as S from '../app/fallback/styles'
import { Contentwrapper } from '@/components/ContentWrapper'
import { storageKeys } from '@/shared/consts/storageKeys'

const NOT_SHOW_CALL_CENTER = [
  'erro-generico',
  'sugestao-expansao-atendimento',
  'especialidade-nao-dispoe-atendimento-para-faixa-etaria',
  'sugestao-cobertura',
  'especialidade-sem-atendimento-no-local-escolhido',
  'genero-sem-atendimento-para-especialidade-no-local'
]

export function FallbackLayout() {
  const isMobile = useIsActiveBreakPoint('medium')
  const { pathname } = useLocation()
  const isNotShowCallCenterPath = NOT_SHOW_CALL_CENTER.find((fallback) =>
    pathname.includes(fallback)
  )
  const isSecondError =
    sessionStorage.getItem(storageKeys.genericErrorShown) === 'true' &&
    pathname.includes('erro-generico')

  const showCallCenter = !isNotShowCallCenterPath || isSecondError

  return (
    <PagesWrapper.Root>
      <PagesWrapper.SideBar>
        <SideBar.Root $marginBottom="1.5rem">
          <SideBar.ContentWithPadding>
            <SideBar.Title type="fallback">Atenção</SideBar.Title>
            <Show when={!isMobile && showCallCenter}>
              <CallCenter.Button />
              <CallCenter.Info />
            </Show>
          </SideBar.ContentWithPadding>
        </SideBar.Root>
      </PagesWrapper.SideBar>
      <PagesWrapper.Body>
        <PagesWrapper.ContentWithIcon>
          <CuraIcon
            color="neutral-dark"
            name="alertTriangle"
            size={48}
            style={{
              marginTop: isMobile ? '0px' : '3px'
            }}
          />
          <S.Content>
            <Contentwrapper>
              <Outlet />
            </Contentwrapper>
            <Show when={isMobile && showCallCenter}>
              <CallCenter.Button />
              <CallCenter.Info />
            </Show>
          </S.Content>
        </PagesWrapper.ContentWithIcon>
      </PagesWrapper.Body>
    </PagesWrapper.Root>
  )
}
